import React from 'react';
import ReactDOM from 'react-dom';
// import registerServiceWorker from './registerServiceWorker';
import {unregister } from './registerServiceWorker';
import './index.css';
import configureStore from './configureStore';
import Boot from './components/Boot';

const store = configureStore();

ReactDOM.render(
  <Boot store={store} />,
  document.getElementById('root')
);

if (module.hot){
  module.hot.accept('./components/Boot', ()=>{
    ReactDOM.render(
      <Boot store={store} />,
      document.getElementById('root')
    );
  });
}
unregister();



// WEBPACK FOOTER //
// ./src/index.js